var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['message-input-button', !_vm.isPC && 'message-input-button-h5']
  }, [_vm.props.enableSend ? _c('button', {
    staticClass: "message-input-button-cont",
    attrs: {
      "data-type": "text",
      "disabled": false
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('p', {
    staticClass: "message-input-button-hover"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.按Enter发送，Ctrl+Enter换行")) + " ")]), _vm._v(" " + _vm._s(_vm.TUITranslateService.t("发送")) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }